export default __webpack_public_path__ + "static/media/vitalizing.08f5944d.jpg";